/**
 * @generated SignedSource<<da8720b798e04e857c96f36e0da5f11c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useUserThumbnailUrl_user$data = {
  readonly actor: {
    readonly __typename: string;
    readonly thumbnailUrl: string;
    readonly " $fragmentSpreads": FragmentRefs<"useArtistThumbnailUrl_artist">;
  } | null;
  readonly " $fragmentType": "useUserThumbnailUrl_user";
};
export type useUserThumbnailUrl_user$key = {
  readonly " $data"?: useUserThumbnailUrl_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"useUserThumbnailUrl_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useUserThumbnailUrl_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "actor",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "thumbnailUrl",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useArtistThumbnailUrl_artist"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UserNode",
  "abstractKey": null
};

(node as any).hash = "1856286070fc443f3f770962f3b311df";

export default node;
